module.exports = __webpack_public_path__ + "media/svgs/booking-calendar-d74c8cb2397b9b2dae4580d17fd5008c.svg";